import './footer.css'
import logo from '../assets/instagram_icon.png'
export default function Footer() {
    return (
        <div className="footer">
            <h3>Follow Us</h3>
            <div className='footerImgWrapper'>
                <a href="https://www.instagram.com/orbis.app?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer">
                    <img src={logo} alt='Orbis logo' />
                </a>
            </div>
            <div className="footer-contact">
                Contact: <a href="mailto:ioanadaiana06@gmail.com">ioanadaiana06@gmail.com</a>
            </div>

        </div>
    )
}